import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import ListItemCreateButton from '../../../../../components/custom/ListItemCreateButton';
import { useFetchedValue } from '../../../../../components/hooks/useFetched';
import { usePageableGrid } from '../../../../../components/hooks/usePageableGrid';
import { Grid, GridColumn } from '../../../../../components/KendoReact/Grid';
import { useWindow } from '../../../../../components/windows/WindowContext';
import AdministrationActionCell from '../../components/AdministrationActionCell';
import GroupCreateModalWindow from './GroupCreateModalWindow';
import GroupEditModalWindow from './GroupEditModalWindow';

const getGroups = async (skip: number, take: number) =>
    api.groups.getGroups({
        skip,
        take
    });

const GroupsPage: FC = () => {
    const { openWindow } = useWindow();
    const [gridPageProps] = usePageableGrid([5, 10, 15, 20, 25], 15);
    const [isLoading, setIsLoading] = useState(false);
    const [groups, refetchGroups, , , isGroupsLoading] = useFetchedValue(getGroups, true, gridPageProps.skip, gridPageProps.take);

    const openGroupEditModalWindow = async (groupId: number) => {
        try {
            GroupEditModalWindow.defaultProps = {
                componentProps: {
                    groupId: groupId,
                    refetchGroups: refetchGroups
                }
            };
            openWindow({
                title: 'Grupės redagavimas',
                component: GroupEditModalWindow,
                isDialogBehaviour: true,
                width: 800,
                height: 400
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const openGroupCreateModalWindow = async () => {
        try {
            GroupCreateModalWindow.defaultProps = {
                componentProps: {
                    refetchGroups: refetchGroups
                }
            };
            openWindow({
                title: 'Grupės kūrimas',
                component: GroupCreateModalWindow,
                isDialogBehaviour: true,
                width: 800,
                height: 400
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const deleteGroup = async (id: number) => {
        try {
            setIsLoading(true);
            await api.groups.deleteGroup(id);
            refetchGroups;
            toast.success('Grupė sėkmingai ištrinta');
        } catch (ex) {
            toast.error('Grupės ištrinti nepavyko, sistemos klaida');
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) return <KendoLoading />;

    return (
        <div>
            <ListItemCreateButton openCreateModal={openGroupCreateModalWindow} />
            <Grid className="mt-2" {...gridPageProps} data={groups} isLoading={isGroupsLoading}>
                <GridColumn
                    width="200px"
                    title="Veiksmai"
                    cell={(c) => (
                        <AdministrationActionCell {...c} fetchData={refetchGroups} deleteItem={deleteGroup} editItem={openGroupEditModalWindow} />
                    )}
                />
                <GridColumn width={200} title="Pavadinimas" field="name_LT" />
                <GridColumn title="Aprašymas" field="description_LT" />
            </Grid>
        </div>
    );
};

export default GroupsPage;
